<template>
    <div :class="['profile-filter', { hidden: filtersHidden }]">
        <div class="profile-filter__selects-container" >
            <div class="profile-filter__selects">
                <!-- <CategoriesFilter ref="categories" :entityList="[...uncompletedCourses, ...uncompletedLearningPaths]" /> -->
                <UncompletedLevelFilter ref="level" :courseList="[...uncompletedCourses, ...uncompletedLearningPaths]" />
                <InstructorFilter ref="instructor" :courseList="[...uncompletedCourses, ...uncompletedLearningPaths]" />
                <AuthorizationFilter ref="authorization" :courseList="[...uncompletedCourses, ...uncompletedLearningPaths]" v-if="!$isLangDk" />
                <ContentTypeFilter ref="contentType" :courseList="[...uncompletedCourses, ...uncompletedLearningPaths]" v-if="!$isLangDk" />
                <TotemSearch class="profile-filter__search-input" v-model="search" v-on:clearSearch="onClearSearch"/>
                <TotemToggleButton
                    v-model="showHiddenCourses"
                    :label="$t('UncompletedFilter.show_hidden_courses')"
                    class="filter-select"
                />
                <TotemToggleButton
                    v-model="showExpiredCourses"
                    :value="showExpiredCourses"
                    :label="$t('CourseListFilter.show_expired_courses')"
                    class="filter-select"
                />
            </div>
        </div>
        <div class="profile-filter__tags">
            <UncompletedTags v-on:removeTag="removeTag" />
            <div class="clear-filters">
                <TotemTag
                    :name="$t('CourseListFilter.clear_all_filters')"
                    @handleClick="removeAllTags"
                    class="desktop-clear-filters"
                    :clearAll="true"
                />
            </div>
        </div>
        <TotemToast ref="toast" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import CategoriesFilter from 'components/user/items-listings/filters/CategoriesFilter'
    import UncompletedLevelFilter from 'components/user/items-listings/filters/UncompletedLevelFilter'
    import InstructorFilter from 'components/user/items-listings/filters/InstructorFilter'
    import AuthorizationFilter from 'components/user/items-listings/filters/AuthorizationFilter'
    import ContentTypeFilter from 'components/user/items-listings/filters/ContentTypeFilter'
    import UncompletedTags from './UncompletedTags'
    import expiredCoursesAndCollections from 'components/shared/mixins/expiredCoursesAndCollections'

    export default {
        props: {
            uncompletedCourses:  {
                type: Array,
                default: () => [],
            },
            uncompletedLearningPaths: {
                type: Array,
                default: () => []
            },
            sorting: {
                type: Function,
                default: () => (el) => el
            },
            learningPathSorting: {
                type: Function,
                default: () => (el) => el
            },
            filtersHidden: {
                type: Boolean,
                default: false
            }
        },
        components: {
            CategoriesFilter,
            UncompletedLevelFilter,
            InstructorFilter,
            AuthorizationFilter,
            ContentTypeFilter,
            UncompletedTags,
        },
        mixins: [ expiredCoursesAndCollections ],
        data () {
            return {
                filterCategories: [],
                search: '',
                filteredData: [],
                showHiddenCourses: false,
                showExpiredCourses: true
            }
        },
        computed: {
            ...mapGetters({
                selectedOptions: 'CourseFilter/getSelectedCategories',
                categories: 'CourseFilter/getCategories',
                selectedLevel: 'CourseFilter/getSelectedLevel',
                selectedInstructor: 'CourseFilter/getSelectedInstructor',
                selectedAuthorization: 'CourseFilter/getSelectedAuthorization',
                selectedContentType: 'CourseFilter/getSelectedContentType'
            }),
            compoundProperty () {
                this.search
                this.selectedOptions
                this.selectedLevel
                this.sorting
                this.learningPathSorting
                this.selectedContentType
                this.selectedInstructor
                this.selectedAuthorization
                this.showHiddenCourses
                this.showExpiredCourses
                return Date.now()
            }
        },
        methods: {
            filter () {
                let filters = [
                    this.filterBySearch,
                    // this.$refs.categories.filterByCategories,
                    this.$refs.level.filterByLevel,
                    this.$refs.instructor.filterByInstructor,
                    this.$refs.authorization?.filterByAuthorization,
                    this.toggleHiddenCourses,
                    this.toggleExpiredCourses
                ].filter(f => typeof f === 'function')

                let courses = Array.isArray(this.uncompletedCourses) ? this.uncompletedCourses : []
                let learningPaths = Array.isArray(this.uncompletedLearningPaths) ? this.uncompletedLearningPaths : []

                let filteredCourses = filters.reduce((acc, filter, index) => {
                    if (filter === null) {
                        return acc
                    }
                    return filter(acc)
                }, courses)
                
                let filteredLearningPaths = filters.reduce((acc, filter, index) => {
                    if (filter === null) {
                        return acc
                    }
                    return filter(acc)
                }, learningPaths)

                if (this.sorting) {
                    filteredCourses = this.sorting(filteredCourses)
                }

                if (this.learningPathSorting) {
                    filteredLearningPaths = this.learningPathSorting(filteredLearningPaths)
                }

                if (this.selectedContentType) {
                    if (this.selectedContentType.id === 0) {
                        filteredCourses = []
                    } else {
                        filteredLearningPaths = []
                    }
                }

                this.filteredData = filteredCourses
                this.$emit('completed-courses-filtered', filteredCourses, filteredLearningPaths)
            },
            filterBySearch (data) {
                if (this.search === '') {
                    return data
                }
                return data.filter(course => course.title.toLowerCase().search(this.search.toLowerCase()) !== -1)
            },
            toggleHiddenCourses (data) {
                if (!this.showHiddenCourses) {
                    return data.filter(el => el.userMetadata.hiddenInUnfinishedCoursesList === false || el.userMetadata.hiddenInUnfinishedList === false)
                }
                return data
            },
            toggleExpiredCourses (data) {
                if (this.showExpiredCourses) {
                    return data
                }
                return data.filter(course => !this.isCourseOrCollectionExpired(course))
            },
            removeAllTags () {
                this.$refs.level.clear()
                this.$refs.instructor.clear()
                this.$refs.authorization?.clear()
                this.$refs.contentType?.clear()
                this.$store.dispatch('CourseFilter/removeAllCategoriesOptions')
                this.search = ''
                this.$emit('clear-filters')
                this.$refs.toast.show(this.$t('CourseListFilter.clear_search_notification'))
            },
            removeTag (tag) {
                this.$refs[tag].clear()
            },
            onClearSearch () {
                this.search = ''
            }
        },
        watch: {
            uncompletedCourses: {
                handler: 'filter'
            },
            uncompletedLearningPaths: {
                handler: 'filter'
            },
            compoundProperty: {
                handler: 'filter'
            }
        },
        created () {
            this.$store.dispatch('CourseFilter/loadCategories')
        },
        beforeDestroy () {
            this.$store.dispatch('CourseFilter/clearFilter')
        }
    }

</script>

<style lang="scss" scoped>
    @include profile_filters;
</style>
